import { aboutInfo } from '@/mocks/homepage';

export default function AboutSection() {
  return (
    <section id="about" className="relative py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">{aboutInfo.title}</h2>
          </div>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-3xl mx-auto mb-10">
            {aboutInfo.description}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
            {aboutInfo.stats.map((stat, idx) => (
              <div
                key={stat.label}
                className="bg-background-200/40 border border-background-200/50 rounded-xl p-5 md:p-6 text-center"
              >
                <div className={`text-2xl md:text-3xl font-bold font-heading mb-1.5 ${
                  idx === 0 ? 'text-primary-400' :
                  idx === 1 ? 'text-accent-400' :
                  idx === 2 ? 'text-secondary-400' :
                  'text-foreground-700'
                }`}>
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}